import fp from 'lodash/fp';
import { userContentCompletionStatus, userEventCompletionStatus } from '../constants';
import { mapRecommendedContent } from './content';
import { mapRecommendedCourses, mapRecommendedEvents } from './event';

const findEvent = (searchTile, searchResult) =>
  searchResult.events.filter(
    event => searchTile.publishedEventId === event.id
  ).map(
    c => ({
      ...c,
      userEventCompletionStatus: searchTile.userContentCompletionStatus === userContentCompletionStatus.InProgress ?
        userEventCompletionStatus.Registered : searchTile.userContentCompletionStatus,
      searchTileId: searchTile.id
    })
  )

const findContent = (searchTile, searchResult) =>
  searchResult.content.filter(c => searchTile.contentId === c.id).map(c => ({ ...c, userContentCompletionStatus: searchTile.userContentCompletionStatus, searchTileId: searchTile.id }))

export const mapRecommendedResult = (cpdCategorys, publishers, business, bookmarks) =>
  fp.flow(
    (result) => result ? result : {
      searchTiles: [],
      content: [],
      events: []
    },
    ({ searchTiles, content, events }) => fp.map(
      (searchTile) => ({
        searchTile,
        searchResult: {
          content,
          events
        }
      })
    )(searchTiles),
    fp.map(
      ({ searchTile, searchResult }) => fp.first((searchTile.searchTileType === "Event") ?
        mapRecommendedEvents(cpdCategorys, publishers)(findEvent(searchTile, searchResult)) :
        (searchTile.searchTileType === "Course") ?
          mapRecommendedCourses(cpdCategorys, publishers)(findEvent(searchTile, searchResult)) :
          mapRecommendedContent(cpdCategorys, publishers, business, bookmarks)(findContent(searchTile, searchResult)))
    )
  )



// WEBPACK FOOTER //
// ./src/services/recommendedResult.js